<page-data-manager>
  <div class="row">
    <div class="col-xs-12">
      <div class='page-header'>
        <h2>Depósitos</h2>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12" ng-show="propriedadesDepositos">
      <div class="panel panel-default">
        <div class="panel-body">
          <small ng-show="propriedadesDepositos.length == 0">Nenhum depósito encontrado!</small>
          <table class="table table-hover table-striped" ng-show="propriedadesDepositos.length > 0">
            <thead>
              <tr>
                <th class="col-xs-4">Propriedade</th>
                <th class="col-xs-4">Depósito</th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="propriedade in propriedadesDepositos track by $index">
                <td class="vertical-middle">{{propriedade.descricao | capitalize}}</td>
                <td class="vertical-middle">{{propriedade.deposito.descricao | capitalize}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</page-data-manager>
